import axios from "../axios"
import {
    IWeeklyReportDetail,
    IWeeklyReportDetailData2,
    IWeeklyReportDetailParams,
    IWeeklyReportDetailParams2,
    IWeeklyReportEditParams2,
    IWeeklyReportExportPdfParams,
    IWeeklyReportHistoryPageData,
    IWeeklyReportHistoryPageParams,
    IWeeklyReportListItemData,
    IWeeklyReportListPageParams
} from "./weeklyReport.types"

/**
 * 监测周报 - 分页查询
 */
export function weeklyReportListPage(params: IWeeklyReportListPageParams) {
    return axios<IWeeklyReportListItemData>({
        method: 'get',
        url: '/monitor/week/getReport',
        params,
    })
}

/**
 * 历史周报 - 分页列表
 */
export function weeklyReportHistoryPage(params: IWeeklyReportHistoryPageParams) {
    return axios<IWeeklyReportHistoryPageData>({
        method: 'get',
        url: '/monitor/week/getReportHistory',
        params,
    })
}

/**
 * 周报详情
 */
export function weeklyReportDetail(params: IWeeklyReportDetailParams) {
    return axios<IWeeklyReportDetail>({
        method: 'get',
        url: '/monitor/week/getWeekReportDetail',
        params,
    })
}

/**
 * 编辑周报
 */
export function weeklyReportEdit(params: IWeeklyReportDetail) {
    return axios<number>({
        method: 'post',
        url: '/monitor/week/updateReport',
        data: params,
    })
}

/**
 * 周报删除
 */
export function weeklyReportDel(id: number) {
    return axios({
        method: 'delete',
        url: `/monitor/week/deleteReport/${id}`,
    })
}

/**
 * 下载Pdf
 */
export function weeklyReportExportPdf(params: IWeeklyReportExportPdfParams) {
    return axios<string>({
        method: 'post',
        url: '/monitor/week/downloadPdf',
        data: params,
    })
}


/**
 * 周报详情2
 */
export function weeklyReportDetail2(params: IWeeklyReportDetailParams2) {
    return axios<IWeeklyReportDetailData2>({
        method: 'get',
        url: '/monitor/week/newWeekReportDetail',
        params,
    })
}

/**
 * 编辑周报2
 */
export function weeklyReportEdit2(params: IWeeklyReportEditParams2) {
    return axios<number>({
        method: 'post',
        url: '/monitor/week/newUpdateReport',
        data: params,
    })
}
